/* tslint:disable */
/* eslint-disable */
/**
 * Admin API
 * Internal Admin API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ChargeInvoice200Response
 */
export interface ChargeInvoice200Response {
    /**
     * 
     * @type {boolean}
     * @memberof ChargeInvoice200Response
     */
    success: boolean;
    /**
     * 
     * @type {string}
     * @memberof ChargeInvoice200Response
     */
    errorMessage?: string;
}

/**
 * Check if a given object implements the ChargeInvoice200Response interface.
 */
export function instanceOfChargeInvoice200Response(value: object): value is ChargeInvoice200Response {
    if (!('success' in value) || value['success'] === undefined) return false;
    return true;
}

export function ChargeInvoice200ResponseFromJSON(json: any): ChargeInvoice200Response {
    return ChargeInvoice200ResponseFromJSONTyped(json, false);
}

export function ChargeInvoice200ResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): ChargeInvoice200Response {
    if (json == null) {
        return json;
    }
    return {
        
        'success': json['success'],
        'errorMessage': json['errorMessage'] == null ? undefined : json['errorMessage'],
    };
}

export function ChargeInvoice200ResponseToJSON(json: any): ChargeInvoice200Response {
    return ChargeInvoice200ResponseToJSONTyped(json, false);
}

export function ChargeInvoice200ResponseToJSONTyped(value?: ChargeInvoice200Response | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'success': value['success'],
        'errorMessage': value['errorMessage'],
    };
}

